import {
  API_CUSTOMER_LIST_V2,
  API_CUSTOMER_CHECK_EXIST,
  API_CUSTOMER_STATUS,
  API_CUSTOMER_DETAIL_V2,
  API_CUSTOMER_CREATE,
  API_CUSTOMER_MODIFY,
  API_CUSTOMER_OPERATE_RECORD
} from './customer'
import { API_EDIT, API_SHOP_INFO } from './shopInfo'
import { API_SETMEAL_LIST } from './setMeal'

/**
 * 需要一对一转换的 子 -> 主 接口，用于不仅仅把admin转成mainAdmin的接口
 */
export const TRANSFORM_URL_TO_MAIN = {
  [API_SETMEAL_LIST]: '/p/wedding/index.php/mainAdmin/APISetMeal/list',
  '/p/wedding/index.php/home/APISetMeal/list':
    '/p/wedding/index.php/mainAdmin/APISetMeal/list',
  '/p/wedding/home/APINotification/readed':
    '/p/wedding/index.php/Mainadmin/APINotification/readed',
  '/p/wedding/home/APINotification/unread_type_count':
    '/p/wedding/Mainadmin/APINotification/unread_type_count',
  '/p/wedding/index.php/home/APINotification/index':
    '/p/wedding/index.php/Mainadmin/APINotification/index'
}
/**
 * 存放所有主账号（shop_type 为5，目前只有司仪团队）需要转换的接口（直接把admin转成mainAdmin）
 * admin/Admin/ShopAdmin -> Mainadmin
 */
export const TRANSFORM_URL_TO_MAIN_AUTO = [
  API_EDIT,
  API_SHOP_INFO,
  // 装修
  '/p/wedding/Admin/APISetMeal/drag_sort',
  // 客资 ------------
  API_CUSTOMER_LIST_V2,
  API_CUSTOMER_CHECK_EXIST,
  API_CUSTOMER_STATUS,
  API_CUSTOMER_DETAIL_V2,
  API_CUSTOMER_CREATE,
  API_CUSTOMER_MODIFY,
  API_CUSTOMER_OPERATE_RECORD,

  '/hps/admin/localServerMerchant/fourRole/setting',

  // 档期 ------------
  '/hps/admin/localServerMerchant/fourRole/memberScheduleList',
  '/hps/admin/localServerMerchant/fourRole/addSchedule',
  '/hps/admin/localServerMerchant/fourRole/checkSchedule',
  '/hps/admin/localServerMerchant/fourRole/scheduleDetail',
  '/hps/admin/localServerMerchant/fourRole/editSchedule',
  '/hps/admin/localServerMerchant/fourRole/groupMemberList',
  '/hps/admin/localServerMerchant/fourRole/delSchedule',
  '/hps/admin/localServerMerchant/fourRole/scheduleStatus'
  // 档期 ------------
]
